import React from 'react'
import { Link } from '@reach/router'

const SelectAnotherYear = () => (
  <div className='results-goback'>
    <Link to='/results'>View results for other years.</Link>
  </div>
)

export default SelectAnotherYear